<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" [floatLabel]="floatLabel">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" role="img" [ngClass]="teamStatusIcon"></span>
    }
    {{ label }}
  </mat-label>

  <input
    matInput
    nimbusNumber
    spellcheck="false"
    autocomplete="off"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    [disabled]="isDisabled"
    [required]="isRequiredControl"
    [errorStateMatcher]="this"
  />

  @if (isClearButtonDisplayed) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }

  <i matSuffix class="up-down-suffix">
    <i class="cursor-pointer" [nimbusIcon]="icons.CHEVRON_UP_LIGHT" (click)="onValueIncDecClick(1)"></i>
    <i class="cursor-pointer" [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT" (click)="onValueIncDecClick(-1)"></i>
  </i>

  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }

  @if (isErrorState()) {
    <mat-error>
      <i class="error-triangle" [nimbusIcon]="icons.EXCLAMATION_TRIANGLE"></i>
      <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
    </mat-error>
  }

  @if (infoMessage && !isErrorState()) {
    <mat-hint align="end">
      <div class="info-wrapper">
        @if (showInfoIcon) {
          <i [nimbusIcon]="icons.INFO_CIRCLE"></i>
        }
        <span class="info">{{ infoMessage }}</span>
        @if (showInfoIcon) {
          <nimbus-tooltip [text]="infoMessage"></nimbus-tooltip>
        }
      </div>
      @if (infoMessageSuffix) {
        <span class="info-message-suffix">{{ infoMessageSuffix }}</span>
      }
    </mat-hint>
  }

  @if (warningMessage) {
    <mat-hint align="start" class="warning">
      <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE"></i>
      {{ warningMessage }}
    </mat-hint>
  }
</mat-form-field>
